/**
 * Construye el automatismo que permite que al cambiar el país, cambien las provincias asociadas
 * Compatible con MisDatos
 * @param $element
 */
export const countrySelectorBuilder = ($element) => {
    const provinceSelectorId = $element.data('country-province-idfield');
    let provinceSelector = $('#' + provinceSelectorId);

    if(!provinceSelector.length) {
        return;
    }

    $element.on('change', function(){
        // const countryCode = $(this).find(":selected").data('country-code');
        const $form       = $(this).closest('form');

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data:  $form.serialize(),
            success: function(html) {
                console.log(provinceSelector)
                provinceSelector.replaceWith(
                    $(html).find('#' + provinceSelectorId)
                );
                provinceSelector = $('#' + provinceSelectorId);

                // $("input[type='tel']").intlTelInput("setCountry", countryCode.toLowerCase());
                // $('#ProfileUser_prefixMobile').val(countryCode);
                // $('#ProfileUser_prefixPhone').val(countryCode);
            }
        });
    });
}
